import { ITheme } from '@aston/themes';
import { createAction, props } from '@ngrx/store';

export const ActionPrefix = 'UserPrefs';

export const UpdatePreferredTheme = createAction(
	`[${ActionPrefix}] Update Preferred Theme`,
	props<{ theme: ITheme }>()
);
